import { render } from "./dutyTypes.vue?vue&type=template&id=435067ac&scoped=true"
import script from "./dutyTypes.vue?vue&type=script&lang=js"
export * from "./dutyTypes.vue?vue&type=script&lang=js"

import "./dutyTypes.vue?vue&type=style&index=0&id=435067ac&lang=scss&scoped=true"

import exportComponent from "D:\\project\\admin-system3\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-435067ac"]])

export default __exports__